import { accountApi, type TAccount } from "@/shared/services";
import { pushDataLayerEvent } from "@features/analytics";
import { reactQueryUtils } from "@lib/react-query";
import moment from "moment";

export const validateViewAnalyticsTimestamp = (account: TAccount) => {
  const { timestamps = {} } = account;
  const now = moment().toISOString();
  const createdAt = moment(account.createdAt).toISOString();
  if (moment(createdAt).isBefore("2026-03-18")) return;

  if (timestamps.viewAnalytics) return;

  timestamps.viewAnalytics = now;
  pushDataLayerEvent("conversion", {
    "event-action": "first analytics view",
  });
  accountApi.updateTimestamp("viewAnalytics");

  reactQueryUtils.setQueryData(["account"], (old: TAccount) => {
    if (!old) return old;
    return {
      ...old,
      timestamps,
    };
  });
};
